import { AuthErrorCodes } from './ErrorCodes'

export type DuplicateUserField = 'email' | 'username'

export const DUPLICATE_USER_FIELD_PATTERNS: ReadonlyArray<
  readonly [RegExp, DuplicateUserField]
> = [
  [/email.*already|already.*email/i, 'email'],
  [/username.*already|already.*username|already taken/i, 'username'],
]

export const DUPLICATE_USER_FIELD_CODES: Readonly<Record<string, DuplicateUserField>> = {
  [AuthErrorCodes.EmailDuplicate]: 'email',
  [AuthErrorCodes.UsernameDuplicate]: 'username',
}

export const DUPLICATE_EMAIL_MESSAGE =
  'The email address is already in use. Please use a different email.'

export const INVALID_USERNAME_MESSAGE =
  'Username can contain only letters, numbers and these symbols: . _ @ + -'
